const binding = { modules: {}, dataActions: {} };

    (binding.modules['conditional-container'] = {
        c: () => require('partner/modules/conditional-container/conditional-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'conditional-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/conditional-container'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };